import { render, staticRenderFns } from "./AddBreakItemModal.vue?vue&type=template&id=706bca51&scoped=true&"
import script from "./AddBreakItemModal.vue?vue&type=script&lang=js&"
export * from "./AddBreakItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bca51",
  null
  
)

export default component.exports